import {jwtDecode} from 'jwt-decode';
import {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Outlet, useNavigate} from 'react-router-dom';

import {logoutStart} from '../../redux/authAction';
import {selectAuth} from '../../redux/selectors';

const AdminProtectedRoute = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const auth = useSelector(selectAuth);

  const token = auth?.tokenData;
  const decodedToken = token ? jwtDecode(token) : {};
  const role = decodedToken?.role;

  //  NOT LOGGED IN
  useEffect(() => {
    if (!auth.loggedIn) {
      navigate('/', {replace: true});            
      dispatch(logoutStart({showLoginModal: true})); 
    }
  }, [auth.loggedIn, navigate, dispatch]);

  if (!auth.loggedIn) {return null;}

  //  LOGGED IN BUT NOT ADMIN
  if (role !== 'ADMIN') {
    navigate('/', {replace: true});
    return null;
  }

  return <Outlet />;
};

export default AdminProtectedRoute;
